import { useEffect } from 'react';

export const ZendeskWidget = () => {
  useEffect(() => {
    const existingScript = document.getElementById('ze-snippet');

    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'ze-snippet';
      script.src = 'https://static.zdassets.com/ekr/snippet.js?key=a493eb76-c2ae-43e4-a517-ac1957b9f3a3';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return null;
};
